import { ComponentStateActions } from '../actions/componentStateActions';

const initialState = {
    textBoxFocused: false,
    inputString: '',
    currentSearchQuery: '',
    focusIndex: -1,
    firstSection: [],
    secondSection: [],
    thirdSection: [],
    browseSpecialtyEnabled: false,
    popularSpecialties: [],
    allSpecialties: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ComponentStateActions.SET_TEXT_BOX_FOCUSED:
            return {
                ...state,
                textBoxFocused: action.focused,
            };
        case ComponentStateActions.SET_INPUT_STRING:
            return {
                ...state,
                inputString: action.inputString,
                focusIndex: -1,
            };
        case ComponentStateActions.SET_CURRENT_SEARCH_QUERY:
            return {
                ...state,
                currentSearchQuery: action.query,
            };
        case ComponentStateActions.NEXT_OPTION:
            return {
                ...state,
                focusIndex: state.focusIndex + 1,
            };
        case ComponentStateActions.PREVIOUS_OPTION:
            return {
                ...state,
                focusIndex: state.focusIndex - 1,
            };
        case ComponentStateActions.SET_FOCUS_INDEX:
            return {
                ...state,
                focusIndex: action.index,
            };
        case ComponentStateActions.SET_FIRST_SECTION:
            return {
                ...state,
                firstSection: action.data,
            };
        case ComponentStateActions.SET_SECOND_SECTION:
            return {
                ...state,
                secondSection: action.data,
            };
        case ComponentStateActions.SET_THIRD_SECTION:
            return {
                ...state,
                thirdSection: action.data,
            };
        case ComponentStateActions.ENABLE_BROWSE_SPECIALTY:
            return {
                ...state,
                browseSpecialtyEnabled: true,
            };
        case ComponentStateActions.SET_POPULAR_SPECIALTIES:
            return {
                ...state,
                popularSpecialties: action.data,
            };
        case ComponentStateActions.SET_ALL_SPECIALTIES:
            return {
                ...state,
                allSpecialties: action.data,
            };
        default:
            return state;
    }
};
